module.exports = __webpack_public_path__ + "fonts/ralewayblackitalic.4efbfd6.woff2";